/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";
import { TimePickerField } from "../../../../atoms/FormFields/TimePickerField";
import { useForm } from "react-hook-form";
import { TimePickerFieldNormal } from "../../../../atoms/FormFields/TimePickerFieldNormal";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  btnApi: () => void;
}

const ChangeShiftYardTime = (props: PropsType) => {
  const { onClose, loading, btnApi } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    console.log(val);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Change shift & yard time </h3>
            <p style={{ color: "#151718" }}>
              You can update the default shift start time and the crew yard time
              at the beginning and end of the day.
            </p>
          </div>
        </div>
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_content">
            <Row gutter={16}>
              <Col span={24}>
                <TimePickerFieldNormal
                  fieldName="startTime"
                  label="Shift start time"
                  control={control}
                  isRequired
                  rules={{
                    required: "Shift start time is required.",
                  }}
                  validate={errors.startTime && "error"}
                  validMessage={
                    typeof errors.startTime?.message === "string"
                      ? errors.startTime.message
                      : undefined
                  }
                  tooltipTitle="Shift start time"
                />
              </Col>
              <Col span={12}>
                <TimePickerField
                  fieldName="timeAtStartPoint"
                  label="Time at start point"
                  control={control}
                  isRequired
                  rules={{
                    required: "Time at start point is required.",
                  }}
                  validate={errors.timeAtStartPoint && "error"}
                  validMessage={
                    typeof errors.timeAtStartPoint?.message === "string"
                      ? errors.timeAtStartPoint.message
                      : undefined
                  }
                  tooltipTitle="Time at start point"
                />
              </Col>
              <Col span={12}>
                <TimePickerField
                  fieldName="timeAtFinishPoint"
                  label="Time at finish point"
                  control={control}
                  isRequired
                  rules={{
                    required: "Time at finish point is required.",
                  }}
                  validate={errors.timeAtFinishPoint && "error"}
                  validMessage={
                    typeof errors.timeAtFinishPoint?.message === "string"
                      ? errors.timeAtFinishPoint.message
                      : undefined
                  }
                  tooltipTitle="Time at finish point"
                />
              </Col>
            </Row>
          </div>
        </Form>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Reschedule visits
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default ChangeShiftYardTime;
